(() => {
  if (customElements.get('samo-uk-distributor')) return;
  let detection;
  const isUkVisitor = () => {
    if (!detection) {
      const root = window.Shopify?.routes?.root || '/';
      detection = fetch(`${root}browsing_context_suggestions.json?country[enabled]=true`, {
        credentials: 'same-origin',
        signal: AbortSignal.timeout(5000)
      })
        .then(response => response.ok ? response.json() : null)
        .then(data => data?.detected_values?.country?.handle === 'GB')
        .catch(() => false)
        .then(isUk => {
          document.documentElement.classList.toggle('samo-hide-prices', isUk);
          document.documentElement.classList.remove('samo-country-pending');
          return isUk;
        });
    }
    return detection;
  };
  isUkVisitor();
  customElements.define('samo-uk-distributor', class extends HTMLElement {
    connectedCallback() {
      this.hidden = true;
      isUkVisitor().then(isUk => {
        if (this.isConnected) this.hidden = !isUk;
      });
    }
  });
})();
